import type { BaseElement } from 'slate';

import type { AlineText } from '../../internal';

export type SuggestionMarkerStart = 'suggestionMarkerStart';
export type SuggestionMarkerEnd = 'suggestionMarkerEnd';
export const suggestionMarkerStartType: SuggestionMarkerStart = 'suggestionMarkerStart';
export const suggestionMarkerEndType: SuggestionMarkerEnd = 'suggestionMarkerEnd';

export type SuggestionActionType = 'edit' | 'accept' | 'reject';

export interface SuggestionMarkerStartElement extends BaseElement {
  children: AlineText[];
  markerId: number;
  reasoning: string;
  suggestionActionType: SuggestionActionType;
  suggestionId: string;
  type: SuggestionMarkerStart;
  /**
   * The user who authored the suggestion (e.g. the AI-chat user whose message
   * produced the edit).
   *
   * Optional ONLY for backwards compatibility with markers created before this
   * field existed. All new code paths that create suggestion markers MUST
   * populate this field — treat as required when writing.
   */
  authorId?: string;
  suggestedEdits?: [] | null;
}

export interface SuggestionMarkerEndElement extends BaseElement {
  children: AlineText[];
  markerId: number;
  type: SuggestionMarkerEnd;
  suggestedEdits?: [] | null;
}

export type SuggestionMarkerElement = SuggestionMarkerStartElement | SuggestionMarkerEndElement;
